const Footer = () => {
    return (
        <footer className="footer">
            <div className="container-fluid"><p className="footer-para">  &copy; 2023 Envoi Live. All rights reserved. </p></div>
        </footer>
    )
}

export default Footer;